import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67a51d2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form" }
const _hoisted_2 = { class: "display" }
const _hoisted_3 = { class: "controls" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Start")
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Pause")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Lap")
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Resume")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Stop")
const _hoisted_13 = { class: "laps" }

import useTracker from '../composables/useTracker'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  clockStatus,
  elapsedFullTime,
  elapsedSplitTime,
  getLaps,
  handleStart,
  handlePause,
  handleStop,
  handleLap
} = useTracker()

return (_ctx: any,_cache: any) => {
  const _component_app_btn = _resolveComponent("app-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", null, _toDisplayString(_unref(elapsedFullTime)), 1),
        _createElementVNode("h3", null, _toDisplayString(_unref(elapsedSplitTime)), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_unref(clockStatus) === 'stopped')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_app_btn, { onClick: _unref(handleStart) }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }, 8, ["onClick"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_unref(clockStatus) === 'running')
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_component_app_btn, { onClick: _unref(handlePause) }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_app_btn, { onClick: _unref(handleLap) }, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true),
              (_unref(clockStatus) === 'paused')
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createVNode(_component_app_btn, { onClick: _unref(handleStart) }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_app_btn, { onClick: _unref(handleStop) }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true)
            ]))
      ]),
      _createElementVNode("div", _hoisted_13, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getLaps)(), (lap, key) => {
          return (_openBlock(), _createElementBlock("h4", {
            key: `${key}_${lap}`
          }, _toDisplayString(lap), 1))
        }), 128))
      ])
    ]),
    _createTextVNode(" " + _toDisplayString(_unref(clockStatus)), 1)
  ], 64))
}
}

})